import { useUnderwritingHook as useLosUnderwritingHook } from "../../hooks/useUnderwritingHook";

/**
 * Bridge to lendmarq-los's underwriting hook, adapting the two submission
 * routes the vendored Submissions screen calls to the parameter names the LOS
 * hook uses. Same endpoints either way — only the argument spelling differs:
 *
 *   tpo `createLoanFromSubmission({ submissionType, submissionId })`
 *     → LOS `createLoanFromSubmission({ submissionType, applicationId })`
 *   tpo `assignSubmissionToLoan({ submissionKind, loanNumber, submission })`
 *     → LOS `assignSubmissionToDeal({ borrower_submission, loanNumber, data })`
 *
 * See src/tpo/README.md.
 */
export const useUnderwritingHook = () => {
  const los = useLosUnderwritingHook();

  const createLoanFromSubmission = async ({
    submissionType,
    submissionId,
    ...rest
  }) =>
    los.createLoanFromSubmission({
      submissionType,
      applicationId: submissionId,
      ...rest,
    });

  const assignSubmissionToLoan = async ({
    submissionKind,
    loanNumber,
    submission,
    ...rest
  }) =>
    los.assignSubmissionToDeal({
      borrower_submission: submissionKind,
      loanNumber,
      data: submission,
      ...rest,
    });

  return { ...los, createLoanFromSubmission, assignSubmissionToLoan };
};

export default useUnderwritingHook;
